export const errorDataMapper = (data: any) => ({
  errorCode: data.error_code,
  invalidCols: data.invalid_cols || null,
  invalidRows: data.invalid_rows || null,
  message: data.message
});
